import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { FaqApiService } from '../../../_services/faqs-service/faq-api.service';
import { Faq } from '../../../_interfaces/faq.interface';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { MarkdownModule } from 'ngx-markdown';
import { helpCenterUrl } from '../../../_fixtures/project-fixtures';

@Component({
  selector: 'app-help-btn',
  imports: [ClickOutsideDirective, NgClass, NgbCollapseModule, MarkdownModule],
  templateUrl: './help-btn.component.html',
})
export class HelpBtnComponent {
  readonly faqApiService = inject(FaqApiService);

  showHelp: boolean = false;
  faqDetails: Faq[] = [];
  expandedIndex: number | null = null;
  readonly helpCenterUrl = helpCenterUrl;
  constructor() {
    this.getFaqs();
  }

  getFaqs() {
    this.faqApiService.getFaqDetails('onboarding').subscribe({
      next: (res) => {
        this.faqDetails = res;
      },
    });
  }

  toggleCollapse(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  showHelpChange() {
    this.showHelp = !this.showHelp;
  }

  closeHelp() {
    if (this.showHelp) {
      this.showHelp = false;
    }
  }

  protected readonly FaqService = FaqApiService;
}
